import {
    DELIVERY_PLAN_AUDIT_LIST,
    DELIVERY_PLAN_AUDIT_LIST_SUCCESS,
    DELIVERY_PLAN_AUDIT_LIST_ERROR,
    DELIVERY_PLAN_AUDIT_MODAL_SET
} from '../../actions';

const INIT_STATE = {
    loading: false,
    error: false,
    modal: false,
    list: { data: [] }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case DELIVERY_PLAN_AUDIT_LIST:
            return { ...state, loading: true, error: false };
        case DELIVERY_PLAN_AUDIT_LIST_SUCCESS:
            return { ...state, loading: false, list: { data: action.payload } };
        case DELIVERY_PLAN_AUDIT_LIST_ERROR:
            return { ...state, loading: false, error: true };
        case DELIVERY_PLAN_AUDIT_MODAL_SET:
            return { ...state, modal: action.payload };
        default:
            return state;
    }
};
